module.exports = __webpack_public_path__ + "img/dan.24d4440d.gif";